import Base from '@/models/Base'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IAddress } from '@/interfaces/IAddress'
import type { IUserNextOfKinDetail } from '@/interfaces/users/IUserNextOfKinDetail'
import NextOfKinDetail from '@/models/NextOfKinDetail'
import Address from '@/models/Address'

class AppUser extends Base implements IAppUser {
  initials?: string
  name: string
  userName: string
  phoneNumber: string
  email: string
  designation?: string
  teamTitle?: string
  employeeCode?: string
  alternatePhoneNumber?: string
  dateOfBirth?: string
  nextOfKinDetail?: IUserNextOfKinDetail
  address?: IAddress
  roles?: string[]
  accesses?: any[]

  constructor(appUser?: any) {
    super(appUser)
    this.initials = appUser?.initials
    this.name = appUser?.name ?? ''
    this.userName = appUser?.userName ?? ''
    this.phoneNumber = appUser?.phoneNumber ?? ''
    this.email = appUser?.email ?? ''
    this.designation = appUser?.designation
    this.teamTitle = appUser?.teamTitle
    this.employeeCode = appUser?.employeeCode
    this.alternatePhoneNumber = appUser?.alternatePhoneNumber
    this.dateOfBirth = appUser?.dateOfBirth
    this.nextOfKinDetail = appUser?.nextOfKinDetail
      ? new NextOfKinDetail(appUser.nextOfKinDetail)
      : undefined
    this.address = appUser?.address ? new Address(appUser.address) : undefined
    this.roles = appUser?.roles
    this.accesses = appUser?.accesses
  }
}

export default AppUser
